import { CommonModule } from '@angular/common';
import { ConnectedAccountsSummaryCardComponent } from './connected-accounts-summary-card.component';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
	declarations: [ConnectedAccountsSummaryCardComponent],
	imports: [
		CommonModule,
		HmfButtonComponent,
		RouterModule
	],
	exports: [ConnectedAccountsSummaryCardComponent]
})
export class ConnectedAccountsSummaryCardModule {}
